export const siteNotesFormSchema = {
  title: "Add/Edit Note",
  id: "siteNotesFormSchema",
  stateTitle: {
    create: "Add Note",
    edit: "Edit Note",
  },
  sections: [
    {
      id: "siteNotesFormSection",
      fields: [
        {
          id: "note", // required
          labelValue: "Note",
          required: true,
          type: "textarea",
          col: 6,
        },
      ],
    },

    {
      id: "siteNotesFormButtonsSection",
      fields: [
        {
          id: "addSiteNote", // required
          type: "button", // required
          labelValue: "Add",
          action: "submit",
          callback: "addSiteNote",
          position: "footer",
          hiddenStates: ["edit"],
          col: 6,
        },
        {
          id: "updateSiteNote", // required
          type: "button", // required
          labelValue: "Update",
          action: "submit",
          callback: "updateSiteNote",
          position: "footer",
          hiddenStates: ["create"],
          col: 6,
        },
        {
          id: "cancelSiteNoteDialog", // required
          type: "button", // required
          labelValue: "Cancel",
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/SiteNotes/siteNotesFormSchema.js